import { assertNotEmpty, dateUtils } from '@festina-life/core'
import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Card, CardBody } from '@festina-life/ui/structure'

import { BlockIndicator } from '../../../components/blockIndicator/BlockIndicator'
import { DocumentationEntry } from '../../../components/documentationEntry/DocumentationEntry'
import { DraftIndicator } from '../../../components/draftIndicator/DraftIndicator'
import { LayerIndicator } from '../../../components/layerIndicator/LayerIndicator'
import { useLayoutContext } from '../../../context/layoutContext'
import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../../uiModels/parameterOperations/types'

type Props = {
  data: IndexedParameterDefinitionCreateOperationWithMetaData
}

export const ParameterNameCell = ({ data }: Props) => {
  const translate = useTranslate()
  const { preferences } = useLayoutContext()
  const definitionEntity = data.internalOperation.entity
  const layer = data.layer

  assertNotEmpty(definitionEntity)

  return (
    <Tooltip
      tip={
        preferences.common.isShowingDocumentationOnHover ? (
          <Card>
            <CardBody
              outerClassName="min-w-250 max-w-(--breakpoint-2xl)"
              innerClassName="grid grid-cols-[auto_1fr] items-start gap-x-10 gap-y-6"
            >
              <DocumentationEntry
                title={translate(
                  'parameterViewer.parameterDetails.description',
                )}
                value={definitionEntity.description}
              />
              <DocumentationEntry
                title={translate('parameterViewer.parameterDetails.startDate')}
                value={dateUtils.dateAsStr(definitionEntity.fromDate)}
              />
            </CardBody>
          </Card>
        ) : null
      }
      className="h-full grow"
    >
      <div className="flex size-full items-center justify-start gap-x-1">
        <h4 className="m-0 pl-2 font-medium">{definitionEntity.name}</h4>
        <BlockIndicator
          block={data.block}
          shouldShowIcon={false}
          isSecondaryBackground={false}
        />
        <LayerIndicator layer={layer} isSecondaryBackground={false} />
        {data?.isDraft && <DraftIndicator />}
      </div>
    </Tooltip>
  )
}
